import React, { useEffect } from 'react';
import InputField from 'src/shared/components/InputField';
import { Formik, Form, FormikErrors } from 'formik';
import Button from 'src/shared/components/Button';
import './login.scss';
import { loginValidationSchema } from './loginValidationSchema';
import { LoginUser } from 'src/models/Login/loginuser.model';
import { AuthType } from 'src/enums/authType';
import { REMOTE_ASSET_PATHS } from 'src/shared/constants/RemoteAssetPath';
import CheckBoxComponent from 'src/shared/components/CheckBoxComponent';
import AuthService from 'src/services/AuthService/auth.service';
import { rememberPasswordOption } from './rememberPasswordOption';
import { Tokens } from 'src/enums/tokens';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'src/routes/routeConstants/appRoutes';

const Login = () => {
  const { buttonLoading, login, forgotPassword } = AuthService();

  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem(Tokens.ACCESS_TOKEN);
    if (accessToken) return navigate(AppRoutes.DASHBOARD);
  }, []);

  const handleSubmit = async (values: LoginUser) => {
    values.authType = AuthType.CREDS;
    await login(values);
  };

  const handleForgotPassword = async (
    values: LoginUser,
    setSubmitting: (isSubmitting: boolean) => void,
    resetForm: () => void,
    validateField: (fieldName: string) => void,
    errors: FormikErrors<LoginUser>,
    setFieldTouched: (fieldName: string) => void
  ) => {
    try {
      setFieldTouched('email');
      await validateField('email');

      if (!values.email || 'email' in errors) return;

      setSubmitting(false);
      await forgotPassword(values.email);
      resetForm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="login">
      <Formik
        initialValues={{
          ...new LoginUser(),
          email: localStorage.getItem(Tokens.EMAIL) as string
        }}
        validationSchema={loginValidationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          setSubmitting,
          resetForm,
          validateField,
          setFieldTouched,
          errors
        }) => (
          <Form>
            <div className="login__container">
              <div className="login__container--logo">
                <img
                  src={REMOTE_ASSET_PATHS.MOHAWK_RECOVER_PROGRAM_LOGO}
                  alt="Mohawk Logo"
                />
              </div>
              <div className="login__container--title">Sign In</div>
              <InputField
                name="email"
                type="text"
                title="Email ID"
                placeholder="Enter Email ID"
              />
              <div className="login__container--password-field">
                <Button
                  type="link"
                  className="forgot-password"
                  onClick={() =>
                    handleForgotPassword(
                      values,
                      setSubmitting,
                      resetForm,
                      validateField,
                      errors,
                      setFieldTouched
                    )
                  }
                >
                  Forgot Password?
                </Button>
                <InputField
                  name="password"
                  type="password"
                  title="Password"
                  placeholder="Enter Password"
                />
              </div>
              <div className="login__container--remember-password">
                <CheckBoxComponent
                  options={rememberPasswordOption}
                  name="rememberPassword"
                  size="small"
                />
              </div>
              <div className="login__container--submit">
                <Button
                  htmlType="submit"
                  type="primary"
                  size="large"
                  loading={buttonLoading}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Login;
